// extracted by mini-css-extract-plugin
export default {"formWrapper":"Login_formWrapper__N1Uwx","title":"Login_title__jI1Mg","form":"Login_form__Q3U-r","forgot":"Login_forgot__y1Zd6","btnWrapper":"Login_btnWrapper__nkGmp"};